<template>
  <span
    v-b-tooltip.hover="{ boundary: 'window' }"
    :title="tooltipTexto"
  >
    <b-btn
      variant="none"
      class="btn-none m-0 icone-acao p-0"
      :disabled="isDisabled"
      @click="atualizar"
    >
      <font-awesome-icon
        :icon="faRefresh"
        :class="iconClass"
        :spin="isLoading"
      />
    </b-btn>
  </span>
</template>

<script>
import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import Vue from 'vue'
import api from '@/app/certificado-digital/shared/services/api'
import EventBus from '@/app/shared/mixins/event-bus/eventBus'

export default {
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faRefresh,
      isLoading: false,
    }
  },
  computed: {
    certificadoVencido() {
      return this.row.situacao === 'CertificadoVencido'
    },
    jaAtualizadoHoje() {
      if (!this.row.ultimaAtualizacaoProcuracaoManual) return false
      const ultima = new Date(this.row.ultimaAtualizacaoProcuracaoManual)
      const hoje = new Date()
      return ultima.getFullYear() === hoje.getFullYear()
        && ultima.getMonth() === hoje.getMonth()
        && ultima.getDate() === hoje.getDate()
    },
    isDisabled() {
      return this.row.porProcuracao === 'Não' || this.certificadoVencido || this.jaAtualizadoHoje || this.isLoading
    },
    iconClass() {
      if (this.row.porProcuracao === 'Não' || this.certificadoVencido || this.jaAtualizadoHoje) return 'text-secondary'
      if (this.row.statusProcuracao === 'vencida') return 'text-danger'
      if (this.row.statusProcuracao === 'avencer') return 'text-warning'
      return 'text-primary'
    },
    tooltipTexto() {
      if (this.row.porProcuracao === 'Não') return 'Certificado sem procuração vinculada'
      if (this.certificadoVencido) return 'Certificado digital vencido'
      if (this.jaAtualizadoHoje) return 'Procuração já atualizada hoje'
      if (this.row.statusProcuracao === 'vencida') return 'Atualizar procuração — possui empresa(s) com procuração vencida'
      if (this.row.statusProcuracao === 'avencer') return 'Atualizar procuração — possui empresa(s) com procuração vencendo em 30 dias'
      return 'Atualizar procuração'
    },
  },
  created() {
    EventBus.$on('atualizacaoProcuracaoFinalizada', this.onProcuracaoFinalizada)
  },
  beforeDestroy() {
    EventBus.$off('atualizacaoProcuracaoFinalizada', this.onProcuracaoFinalizada)
  },
  methods: {
    onProcuracaoFinalizada() {
      this.$emit('atualizado')
    },
    atualizar() {
      if (this.isDisabled) return
      Vue.swal({
        title: 'Atualizar vencimento de procuração',
        html: 'Para iniciar o processo de atualização, informe sua senha de rede.</br></br>',
        input: 'password',
        inputPlaceholder: 'Digite sua senha',
        inputAttributes: {
          autocapitalize: 'off',
          autocorrect: 'off',
          autocomplete: 'new-password',
        },
        icon: 'warning',
        width: '30%',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: {
          popup: 'swal-m',
          confirmButton: 'btn btn-outline-primary mr-50',
          cancelButton: 'btn btn-outline-warning ',
        },
        buttonsStyling: false,
        preConfirm: senha => {
          if (!senha) {
            Vue.swal.showValidationMessage('A senha é obrigatória')
            return false
          }
          return senha
        },
      }).then(result => {
        if (!result.isConfirmed) return
        this.isLoading = true
        api.atualizarVencimentoProcuracao({ certificadoIds: [this.row.id], senha: result.value })
          .then(() => {
            this.$aviso('Atualização de procuração iniciada. Você receberá uma notificação quando concluir.')
          })
          .catch(err => {
            const msg = err?.response?.data?.message === 'A senha de rede especificada não está correta.'
              ? 'Senha inválida!'
              : 'Não foi possível atualizar a procuração. Tente novamente mais tarde.'
            this.$erro(msg)
          })
          .finally(() => {
            this.isLoading = false
          })
      })
    },
  },
}
</script>
